import { useAuthContext } from '@healthblocks-io/core'
import { Navigate, useSearchParams } from 'react-router-dom'

/**
 * Route that redirects to the care payment status page if the user is authenticated
 * If not, it will render the PaymentStatusPage (public page)
 * @param param0
 * @returns
 */
export const PaymentProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const auth = useAuthContext()
  const [searchParameters] = useSearchParams()

  const documentId = searchParameters.get('documentId')
  const responseCode = searchParameters.get('responseCode')

  if (!auth.data.current) {
    return children
  }

  return <Navigate to={`/care/payment-status/${documentId}?responseCode=${responseCode}`} />
}
